export default "{\n    \"label\": \"{{name}}\",\n    \"label_0\": \"Facility\",\n    \"label_plural\": \"{{count}} Facilities\"\n}\n"